import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { LeveragedTokensState } from "@modules/main/components/leveraged-tokens/entities/leveraged-tokens-state.model";
import { Observable } from "rxjs";

const initialSate: LeveragedTokensState = {
	type: null
};

@Injectable({
	providedIn: "root"
})
export class LeveragedTokensStateService extends StateService<LeveragedTokensState> {
	public constructor() {
		super(initialSate);
	}

	public updateType(typeInput: string): void {
		this.setState({ type: typeInput });
	}

	public getState$(): Observable<LeveragedTokensState> {
		return this.select((state) => state);
	}
}
